<template>
  <div class="pre-auth-view">
    <div class="content-container">
      <div class="image-container">
        <img
          alt="Berghoff Design Group Logo"
          src="../../assets/logo-with-text.svg"
        />
      </div>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "PreAuthView"
};
</script>

<style lang="scss" scoped>
.pre-auth-view {
  height: 100vh;
  width: 100vw;

  @apply flex flex-col justify-center items-center;

  .content-container {
    @apply w-full px-5;

    @screen md {
      width: 24rem;
    }

    .image-container {
      @apply w-full mb-16;

      img {
        @apply w-full;
      }
    }
  }
}
</style>
